import React from 'react';

import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import GraphicsPageComments from './Comments';
import FlourishWrapper from './FlourishWrapper';
import GraphicsPageRelatedArticles from './RelatedArticles';
import StaticImageWrapper from './StaticImageWrapper';
import { GraphicSource } from './constants';
import type { GraphicsPageContentProps } from './interfaces';

const GraphicsPageContent = ({
  commentsCount,
  description,
  graphicSource,
  id,
  imageUrl,
  iframe,
  publishDate,
  relatedArticles,
  title,
}: GraphicsPageContentProps) => {
  return (
    <article className="relative flex flex-1 flex-col">
      <div className="invisible absolute left-[-9999em] top-0 print:hidden">
        <h1>{title}</h1>
        <div>{AuthoredContentReactToHtmlParser(description)}</div>
      </div>
      {graphicSource === GraphicSource.Flourish ? (
        <FlourishWrapper fallbackImageURL={imageUrl} iframe={iframe} />
      ) : graphicSource === GraphicSource.Datawrapper ? (
        <div className="relative after:absolute after:-left-6 after:-top-6 after:z-[-1] after:h-[calc(100%+12px)] after:w-[calc(100%+12px)] dark:after:bg-white dark:after:content-['']">
          {AuthoredContentReactToHtmlParser(iframe)}
        </div>
      ) : (
        <StaticImageWrapper description={description} imageUrl={imageUrl} title={title} />
      )}
      <time
        className="mt-8 text-right font-suisse-intl-mono text-disclosure-lg font-normal text-grayscale-gray"
        dateTime={publishDate}
      >
        {publishDate}
      </time>
      <GraphicsPageRelatedArticles relatedArticles={relatedArticles} />
      <GraphicsPageComments id={id} commentsCount={commentsCount} />
    </article>
  );
};

export default GraphicsPageContent;
